import { useDispatch, useSelector } from "react-redux";
import AvailableStatus from "../../../Components/Atoms/AvailableStatus";
import CustomButton from "../../../Components/Atoms/CustomButton";
import NoRecords from "../../../Components/Atoms/NoRecord";
import { DEFAULTS, NOTIFY_TYPE } from "../../../Constant";
import { appUrl } from "../../../Utils/axios";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSingleVisitorLogRequest } from "../../../Redux/VisitorLogs/VisitorLogsActions";

const ViewVisitor = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      dispatch(getSingleVisitorLogRequest({ _id: id }));
    }
  }, [id]);
  const { getSingleVisitorLogsLoading, getSingleVisitorLogsResponse } =
    useSelector((state) => state.visitorLogReducer);
  const data = getSingleVisitorLogsResponse?.data;
  const { getUserResponse } = useSelector((state) => state.user);
  const time_zone =
    getUserResponse?.data?.settings?.time_zone || DEFAULTS.TIME_ZONE;

  const date_time_format =
    getUserResponse?.data?.settings?.date_time_format ||
    DEFAULTS.DATE_TIME_FORMAT;
  const navigate = useNavigate();
  return (
    <>
      <div className="mb-2 d-flex-juscon-flex-end-align-center">
        <CustomButton
          btnType="secondary"
          onClick={() => {
            navigate(-1);
          }}
          label={"Back"}
          action={"BACK"}
        />
      </div>
      <div className="col_2_fr_1_1">
        <div className="left_section">
          <div className="cntr mb-3">
            <h6>BASIC DETAILS</h6>
          </div>
          <div className="d-flex gap-15">
            {data?.basic_details?.primary && (
              <div className="img_container mb-3">
                <img
                  src={`${appUrl}/${data?.basic_details?.primary}`}
                  className="img"
                  onClick={() =>
                    window.open(
                      `${appUrl}/${data?.basic_details?.primary}`,
                      "_blank",
                    )
                  }
                />
              </div>
            )}
            {data?.basic_details?.secondary && (
              <div className="img_container mb-3">
                <img
                  src={`${appUrl}/${data?.basic_details?.secondary}`}
                  className="img"
                  onClick={() =>
                    window.open(
                      `${appUrl}/${data?.basic_details?.secondary}`,
                      "_blank",
                    )
                  }
                />
              </div>
            )}
          </div>
          <div className="details-container">
            <div className="col-md-6 details_list">
              <p className="view_head">NAME</p>
              <p>:</p>
              <p>{data?.basic_details?.name}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">STATUS</p>
              <p>:</p>
              <p>
                <AvailableStatus
                  status={data?.status}
                  customCls={
                    data?.status === "CHECKIN"
                      ? "index-green min-w-20"
                      : "index-red min-w-20"
                  }
                />
              </p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">VISITOR ID</p>
              <p>:</p>
              <p>{data?.visitor_id}</p>
            </div>
            {/* <div className="col-md-6 details_list">
              <p className="view_head">ID TYPE</p>
              <p>:</p>
              <p>{data?.id_type}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head"> VALUE</p>
              <p>:</p>
              <p>
                {data?.id_type === "NRIC"
                  ? data?.nric_masking
                  : data?.id_type === "FIN"
                  ? data?.fin_masking
                  : data?.passport}
              </p>
            </div> */}
            <div className="col-md-6 details_list">
              <p className="view_head">EMAIL</p>
              <p>:</p>
              <p>{data?.basic_details?.email || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">CONTACT NO</p>
              <p>:</p>
              <p>{data?.basic_details?.contact_no || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">DESCRIPTION</p>
              <p>:</p>
              <p>
                {data?.basic_details?.description || DEFAULTS.NOT_AVAILABLE}
              </p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">CHECK-IN</p>
              <p>:</p>
              <p className="th">
                {data?.basic_details?.check_in
                  ? moment(data?.basic_details?.check_in)
                      .tz(time_zone)
                      .format(date_time_format)
                  : DEFAULTS.NOT_AVAILABLE}
              </p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">CHECK-OUT</p>
              <p>:</p>
              <p>
                {data?.basic_details?.check_out
                  ? moment(data?.basic_details?.check_out)
                      .tz(time_zone)
                      .format(date_time_format)
                  : DEFAULTS.NOT_AVAILABLE}
              </p>
            </div>
          </div>
        </div>
        <div className="right_section">
          <div className="cntr mb-3">
            <h6>OTHER DETAILS</h6>
          </div>
          <div className="details-container">
            <div className="col-md-6 details_list">
              <p className="view_head">TYPE</p>
              <p>:</p>
              <p>{data?.other_details?.type?.name || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">PURPOSE OF VISIT</p>
              <p>:</p>
              <p>
                {data?.other_details?.purpose_of_visit?.name ||
                  DEFAULTS.NOT_AVAILABLE}
              </p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">FROM</p>
              <p>:</p>
              <p>{data?.other_details?.from || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">CLIENT</p>
              <p>:</p>
              <p>
                {data?.other_details?.client?.name || DEFAULTS.NOT_AVAILABLE}
              </p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">DESTINATION</p>
              <p>:</p>
              <p>
                {data?.other_details?.destination?.name ||
                  DEFAULTS.NOT_AVAILABLE}
              </p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">BLOCK</p>
              <p>:</p>
              <p>{data?.other_details?.block || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">FLOOR</p>
              <p>:</p>
              <p>{data?.other_details?.floor || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">UNIT NO</p>
              <p>:</p>
              <p>{data?.other_details?.unit_no || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">PASS TYPE</p>
              <p>:</p>
              <p>{data?.other_details?.pass_type || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">PASS NO</p>
              <p>:</p>
              <p>{data?.other_details?.pass_no || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">VEHICLE NO</p>
              <p>:</p>
              <p>{data?.other_details?.vehicle_no || DEFAULTS.NOT_AVAILABLE}</p>
            </div>
            <div className="col-md-6 details_list">
              <p className="view_head">CHECK OUT METHOD</p>
              <p>:</p>
              <p>
                {data?.checkout_method
                  ? data.checkout_method
                  : DEFAULTS.NOT_AVAILABLE}
              </p>
            </div>
            {data?.status_by && (
              <div className="col-md-6 details_list">
                <p className="view_head">STATUS BY</p>
                <p>:</p>
                <p>
                  {`${data?.status_by?.employee_id} - ${data?.status_by?.first_name}`}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <hr />
      <div className="col_2_fr_1_1">
        <div className="left_section">
          <div>
            <div className="cntr mb-3">
              <h6>HOST DETAILS</h6>
            </div>
            <div className="details-container">
              <div className="col-md-6 details_list">
                <p className="view_head">HOST DEPARTMENT</p>
                <p>:</p>
                <p>
                  {data?.host_details?.host_department?.name ||
                    DEFAULTS.NOT_AVAILABLE}
                </p>
              </div>
              <div className="col-md-6 details_list">
                <p className="view_head">HOST NAME</p>
                <p>:</p>
                <p>{data?.host_details?.host_name || DEFAULTS.NOT_AVAILABLE}</p>
              </div>
              <div className="col-md-6 details_list">
                <p className="view_head">HOST CONTACT NO</p>
                <p>:</p>
                <p>
                  {data?.host_details?.host_contact_no ||
                    DEFAULTS.NOT_AVAILABLE}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="right_section">
          <div>
            <div className="cntr mb-3 mt-2">
              <h6>OTP VERFICATION DETAILS</h6>
            </div>
            <div className="details-container">
              {data?.otp_details?.verification_mode && (
                <div className="col-md-6 details_list">
                  <p className="view_head">VERIFICATION MODE</p>
                  <p>:</p>
                  <p>
                    <AvailableStatus
                      status={data?.otp_details?.verification_mode}
                      customCls={
                        data?.otp_details?.verification_mode === "EMAIL"
                          ? "index-orange-mild min-w-20"
                          : "index-green min-w-20"
                      }
                    />
                  </p>
                </div>
              )}
              <div className="col-md-6 details_list">
                <p className="view_head">VERIFIED ON</p>
                <p>:</p>
                <p>
                  {data?.otp_details?.otp_verified_on
                    ? moment(data?.otp_details?.otp_verified_on)
                        .tz(time_zone)
                        .format(date_time_format)
                    : DEFAULTS.NOT_AVAILABLE}
                </p>
              </div>
              {data?.created_by && (
                <div className="col-md-6 details_list">
                  <p className="view_head">VERIFIED BY</p>
                  <p>:</p>
                  <p>
                    {`${data?.created_by?.employee_id} - ${data?.created_by?.first_name}`}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div>
        <div className="cntr mb-3 mt-2">
          <h6>REMINDER INTERVALS</h6>
        </div>
        <div className="tblWrpr mb-15">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <th>NOTIFY TYPE</th>
                  <th>MODE</th>
                  <th>INTERVAL</th>
                  <th>IS DELIVERED</th>
                  <th>DELIVERED AT</th>
                </tr>
              </thead>
              <tbody>
                {data?.reminder_interval?.length > 0 ? (
                  data?.reminder_interval?.map((data, index) => (
                    <tr key={index}>
                      <td> {index + 1}</td>
                      <td> {NOTIFY_TYPE[data?.notify_type]}</td>
                      <td>
                        <AvailableStatus
                          customCls={
                            data?.mode === "TIME"
                              ? "index-green"
                              : "index-orange-mild"
                          }
                          status={data?.mode}
                        />
                      </td>
                      <td>
                        {data?.mode === "TIME"
                          ? `${data?.hours} Hr - ${data?.minutes} Min`
                          : `${data?.days} Day (s)`}
                      </td>
                      <td>
                        <AvailableStatus
                          customCls={
                            data?.is_delivered ? "index-green" : "index-red"
                          }
                          status={data?.is_delivered ? "Yes" : "No"}
                        />
                      </td>
                      <td>
                        {data?.delivered_at
                          ? moment(data?.delivered_at)
                              .tz(time_zone)
                              .format(date_time_format)
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoRecords />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewVisitor;
